// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jut4xH1qCtIZLtWsxN4L{justify-content:center;align-items:center;height:100%;padding-bottom:115px;display:flex}.akPpjkZRdKU7gvQiZLKx{padding-bottom:102px}.DO6MIt_PATJ7Q7Ecto9c{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Jut4xH1qCtIZLtWsxN4L`,
	"wrap--empty": `akPpjkZRdKU7gvQiZLKx`,
	"wrapEmpty": `akPpjkZRdKU7gvQiZLKx`,
	"wrap__text": `DO6MIt_PATJ7Q7Ecto9c`,
	"wrapText": `DO6MIt_PATJ7Q7Ecto9c`
};
export default ___CSS_LOADER_EXPORT___;
